module.exports = __webpack_public_path__ + "img/bannok-beer-kiss-me-deadly-stout.f6fb7995.png";